import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CarrierFleetBoardService,
  FleetBoardOfferRequest,
  FleetBoardModel,
  FleetBoardRequest,
  FleetBoardFilterRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsVoidType, RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CarrierFleetBoardApiService {
  constructor(private apiService: CarrierFleetBoardService) {}

  public acceptLoad(carrierId: string, loadId: string, vehicleId: string, body: FleetBoardOfferRequest, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierFleetBoardAcceptLoad(carrierId, loadId, vehicleId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getBoard(carrierId: string, body: FleetBoardRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<FleetBoardModel[]> {
    return this.apiService.carrierFleetBoardGet(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public ignoreLoad(carrierId: string, loadId: string, vehicleId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierFleetBoardIgnoreLoad(carrierId, loadId, vehicleId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setVehicleFilter(carrierId: string, vehicleId: string, body: FleetBoardFilterRequest, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierFleetBoardSetFilter(carrierId, vehicleId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
